export const networks = {
  1: {
    name: 'Ethereum Mainnet',
    chainId: 1,
    shortName: 'eth',
    chain: 'ETH',
    production: true,
    rpcUrl: `https://eth-mainnet.gateway.pokt.network/v1/${process.env.VUE_APP_ETH_RPC_KEY}`,
    scanUrl: 'https://etherscan.io'
  },
  4: {
    name: 'Ethereum Testnet Rinkeby',
    chainId: 4,
    shortName: 'rin',
    chain: 'ETH',
    production: false,
    rpcUrl: 'https://ropsten.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161',
    scanUrl: 'https://rinkeby.etherscan.io/'
  },
  137: {
    name: 'Matic Mainnet',
    chainId: 137,
    shortName: 'matic',
    chain: 'Matic',
    production: true,
    rpcUrl: `https://polygon-mainnet.g.alchemy.com/v2/${process.env.VUE_APP_POLYGON_RPC_KEY}`,
    scanUrl: 'https://polygonscan.com/'
  },
  80001: {
    name: 'Matic Testnet Mumbai',
    chainId: 80001,
    shortName: 'maticmum',
    chain: 'Matic',
    production: false,
    rpcUrl: 'https://rpc-mumbai.maticvigil.com/',
    scanUrl: 'https://mumbai-explorer.matic.today'
  }
}

export const networksUI = {
  1: {
    chainId: 1,
    name: 'Ethereum',
    background: '#ECF0FC',
    iconSrc: 'eth.png',
    production: true
  },
  4: {
    chainId: 4,
    name: 'Rinkeby',
    background: '#ECF0FC',
    iconSrc: 'eth.png',
    production: false
  },
  137: {
    chainId: 137,
    name: 'Polygon',
    background: '#EEE6FC',
    iconSrc: 'polygon.png',
    production: true
  },
  80001: {
    chainId: 80001,
    name: 'Mumbai',
    background: '#EEE6FC',
    iconSrc: 'polygon.png',
    production: false
  },
}
